/**
 * VERSIONE LIBRERIA 3
 */

/**
 * Versione 0.7
 *
 * extra attributes
 *
 * data-ajax 			: 	attiva la trasformazione sull'elemento
 *
 * data-container 		: 	selettore container puo' essere un id o un class css, qualsiasi valido
 * 							jquery selector (#myid .myclass)
 *
 * data-callback		: 	funzione callback che verra' richiamata dopo il caricamento del contenuto ajax o del template, callback(data,JQE)
 *
 * data-content			:  url del file di template da caricare dentro il contenitore
 *
 * data-lang			: key in lingua per siti multilingua
 *
 * data-lang_p0...pn	: parametri per traduzioni parametriche variabile da 0 a n, secondo i parametri necessari
 *
 * data-visible 		: esegue l'eval del contenuto per stabilire se l'elemento deve essere nascosto o visible
 * 						  inserire codice javascript valido
 *
 * data-remove			: come data-visible ma l'elemento viene rimosso
 *
 * $.dialogsOption : funzione per settare i titoli di default delle dialog
 *
 * $.parseTemplate : funzione...
 */

jQuery.fn.extend({
    ok: function(f) {
        $(this).find('.btok').unbind();
        $(this).find('.btok').click(function() {
            f();
            return true;
        });
        return $(this);
    },
    cancel: function(f) {
        $(this).find('.btcancel').unbind();
        $(this).find('.btcancel').click(function() {
            f();
            return true;
        });
        return $(this);
    }/*,
    hide : function (f) {
        $(this).localf = f;
        $(this).on('hidden.bs.modal', function () {
        	if ($(this).localf)
                return $(this).localf();
        });
        return $(this);
    }*/
});

$.ajaxContent = function(selector, mainCallback,options) {
    var self = this;
    self.info = function(msg) {
    	try {
    		log.info(msg);
    	} catch(e){ console.log(msg);}
    };
    self.warn = function(msg) {
        return self.info(msg);
        if (self.activeDebug && console && console.warn)
            console.warn(msg);
    };

    self.error = function(msg) {
        return self.info(msg);
        if (self.activeDebug && console && console.error)
            console.error(msg);
    };
    self.debug = function(msg) {
        return self.info(msg);
        if (self.activeDebug && console && console.debug)
            console.debug(msg);
    };

    self._isFunction = function(f) {
        return (typeof window[f] === "function");
    };

    self._ajax = function(method, params, jQE) {
        if (self._isFunction(jQE.data("precall"))) {
            if (!window[jQE.data("precall")](jQE))
                return false;
        }
        if (jQE.data("container")) {
            $(jQE.data("container")).html(self.loader);
        }
        var url = jQE.is("form") ? jQE.attr("action") : jQE.attr("href");

        method(Facade.getUrl(url), params, function(data) {

            if (self._isFunction(jQE.data("callback"))) {
                window[jQE.data("callback")](data, jQE);
                return;
            }

            // se ho il template il risultato e' un un json
            if (jQE.data("template")) {
                self._renderTemplate(jQE, data);
                return;
            }
            if (jQE.data("container")) {
                $(jQE.data("container")).html(data);
                //self.debug("riapplico ajaxContent");
                //$(jQE.data("container")).ajaxContent();
                $.ajaxContent(jQE.data("container"));
                return;
            }

            self.warn("non trovata nessuna regola per la gestione del data");

        }).fail(function(data) {
            self.error("fail");
            self.error(data);
            $.waitDialogClose();
            $.errorDialog("500 Internal Server Error");
        });

        return false;
    };

    self._parsePage = function (local_callback) {
    	self.info("_parsePage");
    	$.each($(selector).find('button[data-page]'), function() {

            try {

                var jQE = $(this);
                self.info("found button, data-page  " + jQE.data("page") + " data-callback " + jQE.data("callback") + ":" + jQE.data("app_name"));
                var callback = jQE.data("callback")?jQE.data("callback"):null;
                jQE.unbind('click');
                jQE.click(function() {
                	try {
                		(window[jQE.data("app_name")]).loadPage(jQE.data("page"),callback);
                	} catch(e) {
                		alert(e.message);
                	}

                });
            } catch (e) {
            	self.info(e.message);
                return local_callback(e);
            }

        });
    	local_callback();
    },
    self._parseIncludes = function(local_callback) {
    	self.info("_parseIncludes");
        $.each($(selector).find('div[data-content]'), function() {

            try {
            	var jQE = $(this);
                self.info("found div, data-content  " + jQE.data("content") + " data-callback " + jQE.data("callback"));
            	var html = $.ajax({
                    type: "GET",
                    url: jQE.data("content"),
                    async: false
                }).responseText;
            	jQE.html(html);
            	if (jQE.data("callback") && self._isFunction(jQE.data("callback"))) {
                    window[jQE.data("callback")](jQE);
                }
            } catch (e) {
                self.error("parseInclude error " + e.message);
                return local_callback(e);

            }

        });
        local_callback();
    };

    self._parseLinks = function(local_callback) {
    	self.info("_parseLinks");
        $.each($(selector).find('a[data-ajax]'), function() {
            var jQE = $(this);
            self.info("found a, container  " + jQE.data("container") + " precall " + jQE.data("precall") + " cb " + jQE.data("callback"));
            jQE.unbind('click');
            jQE.click(function() {
                if ($(this).data("confirm")) {
                    $.confirmDialog(jQE.data("confirm")).ok(function() {
                        self._ajax($.get, {}, jQE);
                    });
                } else
                    self._ajax($.get, {}, jQE);
                return false;
            });
        });
        local_callback();
    };

    self._parseForms = function(local_callback) {
    	self.info("_parseForms");
        $.each($(selector).find('form[data-ajax]'), function() {
            var jQE = $(this);
            self.info("found form name:" + jQE.attr("name") + ", container:" + jQE.data("container"));
            jQE.unbind('submit');
            jQE.submit(function() {
            	//alert("ok ");
                //var action = jQE.attr("action");

                var params = jQE.serialize();
                var method = $.get;
                // compatibilita' con versione 1.9 di jquery
                var attr = jQE.attr("method");
                if (typeof attr === 'object')
                    attr = jQE.prop("method");

                if (attr && attr.toLowerCase() == "post")
                    method = $.post;

                if (jQE.data("confirm")) {
                    $.confirmDialog(jQE.data("confirm")).ok(function() {
                        self._ajax(method, params, jQE);
                    });
                } else
                    self._ajax(method, params, jQE);

                return false;
            });
        });
        local_callback();
    };

    self._parseLang = function (local_callback) {
    	self.info("_parseLang " + $('[data-lang]').length);
    	$.translateDocument(selector,function () {
    		local_callback();
    	})
    };

    self._renderTemplate = function(jQE, json) {
        var tplId = jQE.data("template");
        if ($(tplId).size() == 0) {
            self.warn("nessun template trovato");
            return;
        }
        $.renderJson(jQE.data("template"), jQE.data("container"), json);
    };




    self._parseIncludes(function () {
		self._parseLinks(function () {
			self._parseLang(function () {
	    		self._parseForms(function () {
	    			self._parsePage(function () {
        				if (mainCallback) {
        					mainCallback();
        				}
        			});
        		});
        	});
    	});
    });



};

$.translateDocument = function (selector,callback) {
	log.info("translateDocument " + selector);
	var localThis = this;
	localThis._translate = function (jQE,placeholder) {
		var params = [];
		var i = 0;
		while(jQE.data('lang_p'+i) ) {
			params.push(jQE.data('lang_p'+i) );
			i++;
		}
	//$.each($(selector).find('button[data-lang]'), function() {
		//self.info("found " + $(this).prop('tagName'));
		switch(jQE.prop("tagName") ) {
		case 'INPUT':
		case 'SELECT':
		case 'TEXTAREA':
			if (placeholder)
				jQE.attr("placeholder",$.translate(jQE.attr('placeholder'),params));
			else
				jQE.val( $.translate(jQE.data('lang'),params));
			break;
		default:
			//log.debug("translate to " + self.lang_defs[$(this).data('lang')]);
			jQE.html($.translate(jQE.data('lang'),params));
			break;
		}
	};

	try {

		$.each($(selector).find('[data-lang],[placeholder]'),function () {
			var jQE = $(this);
			if (jQE.attr('placeholder'))
				localThis._translate(jQE,true);
			else
				localThis._translate(jQE,false);
        });
		// cerco traduzioni anche nei template in tag script

		$.each($(selector).find('script[id]'),function () {
			var obj = $('<div/>');
			obj.html( $(this).html());
			$.each(obj.find("[data-lang]"), function() {

				var jQE = $(this);
				log.info("found data in script " + jQE.data('lang') + " " + jQE.prop('tagName') + $.translate(jQE.data('lang')));
				localThis._translate(jQE);
			});
			$(this).html(obj.html());
		});

		//$.each()
	 } catch (e) {
     	self.info(e.message);
     	if (callaback)
     		return callback(e);
     	else {
     		log.error("Errore in translateDocument");
     		log.error(e);
     	}
     }
	 if (callback)
		 callback();
};

$.containerInit = function(attrs) {
	var attributes = "";
	if (attrs) {
		for (var k in attrs) {
			attributes += "data-"+ k + '="' + attrs[k] + '" ';
		}
	}
	// confirm dialog Template
    var dlgTemplate =
		'<div id="confirmDialog" class="modal fade">\
		  <div class="modal-dialog">\
		    <div class="modal-content">\
		      <div class="modal-header">\
		        <button type="button" class="close btcancel" data-dismiss="modal" aria-hidden="true">&times;</button>\
		        <h4 class="modal-title">Richiesta di Conferma</h4>\
		      </div>\
		      <div class="modal-body">\
		      	<span class="msg">Sei Sicuro?</span>\
		      </div>\
		      <div class="modal-footer">\
		        <button type="button" class="btn btn-primary btok" data-dismiss="modal">Si</button>\
		        <button type="button" class="btn btn-primary btcancel" data-dismiss="modal">No</button>\
		      </div>\
		    </div><!-- /.modal-content -->\
		  </div><!-- /.modal-dialog -->\
		</div><!-- /.modal -->';
    $('body').append(dlgTemplate);

    //  message dialog template
    dlgTemplate =
            '<div id="messageDialog" class="modal fade">\
				  <div class="modal-dialog">\
	    <div class="modal-content">\
	      <div class="modal-header">\
	        <button type="button" class="close btok" data-dismiss="modal" aria-hidden="true">&times;</button>\
	        <h4 class="modal-title">Informazione</h4>\
	      </div>\
	      <div class="modal-body">\
				<div class="alert alert-info">\
					<span class="msg">message</span>\
				</div>\
	      </div>\
	      <div class="modal-footer">\
	        <button type="button" class="btn btn-primary btok" data-dismiss="modal">Chiudi</button>\
		  </div>\
	    </div><!-- /.modal-content -->\
	  </div><!-- /.modal-dialog -->\
	</div><!-- /.modal -->';
    $('body').append(dlgTemplate);
    // error dialog template
    dlgTemplate =
            '<div id="errorDialog" class="modal fade">\
				  <div class="modal-dialog">\
				    <div class="modal-content ">\
				      <div class="modal-header">\
				        <button type="button" class="close btcancel" data-dismiss="modal" aria-hidden="true">&times;</button>\
				        <h4 class="modal-title">Messaggio Errore</h4>\
				      </div>\
				      <div class="modal-body">\
						<div class="alert alert-danger">\
				      		<span class="msg">Error</span>\
						</div>\
				      </div>\
				      <div class="modal-footer">\
				        <button type="button" class="btn btn-primary btok" data-dismiss="modal">Chiudi</button>\
				      </div>\
				    </div><!-- /.modal-content -->\
				  </div><!-- /.modal-dialog -->\
				</div><!-- /.modal -->';
    $('body').append(dlgTemplate);
    // progress dialog template
    dlgTemplate =
            '<div id="progress_dialog" class="modal fade">\
				  <div class="modal-dialog">\
				    <div class="modal-content">\
				      <div class="modal-header">\
				        <button type="button" class="close btcancel" data-dismiss="modal" aria-hidden="true">&times;</button>\
				        <h4 class="modal-title">Caricamento</h4>\
				      </div>\
				      <div class="modal-body">\
				      	<div class="progress progress-striped active">\
								<div class="progress-bar progress-bar-info" role="progressbar" aria-valuenow="" aria-valuemin="0" aria-valuemax="100" style="width: 100%"></div>\
							</div>\
				      </div>\
				      <div class="modal-footer">\
				        <button type="button" class="btn btn-primary btok" data-dismiss="modal">Chiudi</button>\
				      </div>\
				    </div><!-- /.modal-content -->\
				  </div><!-- /.modal-dialog -->\
				</div><!-- /.modal -->';
    $('body').append(dlgTemplate);
    dlgTemplate =
            '<div id="waitDialog" class="modal fade">\
				  <div class="modal-dialog">\
				    <div class="modal-content">\
				      <div class="modal-header">\
				        <button type="button" class="close btcancel" data-dismiss="modal" aria-hidden="true">&times;</button>\
				        <h4 class="modal-title">Attendere</h4>\
				      </div>\
				      <div class="modal-body text-center">\
						<i class="fa fa-cog fa-spin fa-3x"></i>\
				      </div>\
				      <div class="modal-footer">\
				      </div>\
				    </div><!-- /.modal-content -->\
				  </div><!-- /.modal-dialog -->\
				</div><!-- /.modal -->';
    $('body').append(dlgTemplate);

    dlgTemplate =
        '<div id="generalDialog" class="modal fade">\
			  <div class="modal-dialog">\
			    <div class="modal-content">\
			      <div class="modal-header">\
			        <button type="button" class="close btcancel" data-dismiss="modal" aria-hidden="true">&times;</button>\
			        <h4 class="modal-title">Titolo</h4>\
			      </div>\
			      <div data-modal_error class="alert alert-danger hide "></div>\
			      <div class="modal-body">\
			      </div>\
			      <div class="modal-footer">\
    				<button type="button" class="btn btn-primary btok" data-dismiss="modal">Si</button>\
        			<button type="button" class="btn btn-primary btcancel" data-dismiss="modal">No</button>\
			      </div>\
			    </div><!-- /.modal-content -->\
			  </div><!-- /.modal-dialog -->\
			</div><!-- /.modal -->';
    $('body').append(dlgTemplate);

    // container di uso generale per i vari render dei template script
    $('body').append('<div id="general_container" class="hide"></div>');
    $('body').append('<div id="wait" class="overlay hide">' +
					'<span data-msg style="position:absolute;width:100%;top:50%;text-align:center;color:white"></span>' +
					'</div>');
};

$.locale = "it";

$.langDefs = {};


$.createDynamicContainer = function (sourceTemplate) {
	var id= "dy_"+ (new Date().getTime()) + "_" + (Math.floor(Math.random() * 10000));
	jQuery('<div/>', {
	    id: id,
	    class : 'hide'
	}).appendTo('body');
	if (sourceTemplate)
		$('#'+id).html($.getDomTemplate(sourceTemplate).html());
	else
		$('#'+id).html(" ");
	return $('#'+id);
}

$.generalContainer = function () {
	return $('#general_container');
}

$.generalContainer.selector = function () {
	return '#general_container';
}

$.waitStart = function (msg,container) {
    if (container) {
        jQuery(container).fadeTo('slow',.30).css('pointer-events','none').css('cursor','wait');
        return ;
    }

    if (msg) {
        $('#wait').find('[data-msg]').html(msg);
    }
	$('#wait').removeClass('hide');
	$('#wait').css('cursor','wait');
}

$.waitEnd = function (container) {
    if (container) {
        jQuery(container).fadeTo('slow',1).css('cursor','auto').css('pointer-events','auto');
        return ;
    }
	$('#wait').addClass('hide');
	$('#wait').css('cursor','default');
    $('#wait').find('[data-msg]').html("");
}

$.translate = function (key,plural,params) {
	var s = $.langDefs[key];
	if (!s)
		return key;
    var testo = s;
    if (testo.indexOf('|') >= 0) {
        if (plural > 0) {
            var tmp = testo.split("|");
            testo = tmp.length>plural?tmp[plural]:tmp[0];
        } else 
            testo = testo.substr(0, testo.indexOf('|'));
    }
	if (params instanceof Array) {
		for (var i = 0; i < params.length; i++) {
			testo= testo.replace("(" + i +")", params[i] );
		}
	}
	return testo;
};

$.translateRaw = function (key,plural,params) {
    var s = $.translate(key,plural,params);
    if (s === key) {
        return "";
    }
    return s;
};

$.getDomTemplate = function (id) {
	if ( $(id).prop("tagName") != "SCRIPT")
		return $(id);
	var obj = $('<div/>');
	if ($(id).children().length ) {
		obj.html($(id).children()[0].outerHTML);
	} else if ($(id).length == 1){
		obj.html( $(id).html());
	} else {
		log.error("template not found with id " + id);
	}
	return obj;
};


$.loadBody = function (url_content,callback,pc) {
	var page_container = pc?pc:"#page_container";
	try {
		console.log("loadbody... " + url_content);
		$.get(url_content,{},function (data) {
			console.log("loaded");
			$(page_container).html(data);
			if (callback)
				callback();
		}).fail(function (dataText) {
			console.log(dataText);
			alert("failed to load " + url_content);
		});
	} catch(e) {
		alert("loadBody " + e.message);
	}

};


$.cupparisDateFormat = function (key) {
	var formats = {
		'numeric' : { year: 'numeric', month: '2-digit', day: '2-digit' },
		'numeric-time' : { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit'},
		'short' : { year: 'numeric', month: 'short', day: '2-digit' },
		'short-2' : { month: 'short', day: '2-digit' },
		'medium' : { year: 'numeric', month: 'long', day: '2-digit' },
		'long' : { year: 'numeric', month: 'long', day: '2-digit', weekday: 'long' },
		'short-time' : { hour: '2-digit', minute: '2-digit'},
		'long-time' : { year: 'numeric', month: 'long', day: '2-digit', weekday: 'long', hour: '2-digit', minute: '2-digit', second: '2-digit'},
		'time' :{hour: '2-digit', minute: '2-digit', second: '2-digit'},
		'year' : {year:'numeric'},
		'year-month' : {year:'numeric',month:'long'},

	}

	return formats[key]?formats[key]:"";
}

// accumulatore per calcolo del tempo perso per i renders dei template
$.renderTimeAmount = 0.0;
/**
 * renderJson renderizza un html sostituendo i valori presenti in alcuni attributi con i valori passati
 * dal json.
 * @sourceContainer : rappresenta il contenitore sorgente che verra' parserizzato e sostituiti i valori con i json passato
 * @destContainer : rappresente il contenitore html che riceverera' il risultato del parsing di sourceContainer con i valori
 * 					presenti nel json
 * @value : array associativo o array di array associati
 * @father : in caso di sotto template i valori correnti del padre
 *
 * attributi speciali
 *
 * data-field :			indica il nome del campo nel vettore associativo da renderizzare nell'elemento html
 * data-template : 		indica un template esterno da utilizzare con data-field da utilizzare per renderizzare il
 * 				   		valore. In questo caso si creano i template innestati e il data-field puo' essere un vettore
 * 						o un valore
 * data-totranslate:	indica che la key dentro l'attributo data-field deve essere concatenato con '_'+lang per otternere il valore
 * data-trim:			contiene un numero che indica che il valore deve essere trimmato del valore di data-trim
 * data-date:			indica che data-field e' un valore di data e usa il pattern di data-date per renderizzare
 * 						la data
 *
 */
$.renderJson = function(sourceContainer, destContainer, data,father) {
	//log.info("renderJson " + sourceContainer + " to " + destContainer);
	// funzione locale chiamata per render del singolo elmento
	var renderJsonElement = function (jQelement,data,counter,length) {
		//log.info(RIENTRO + jQelement.html()  + " " + JSON.stringify(data) )
        if (jQelement.attr('data-debug')) {
            log.debug('renderJson DEBUG:','data-attrs',jQelement.data(),'data-param',data,'counter',counter,'length',length);
            //return ;
        }
		var attrField = jQelement.attr('data-field');
		try {
			//if (jQelement.data('field')) {
			if (typeof attrField !== typeof undefined && attrField !== false) {// i lang non devo fare niente solo controllare l'attributo visible
				if (jQelement.data('template') || jQelement.data('self')) {

					var tplId = jQelement.data('template')?jQelement.data('template'):jQelement.data('self');
					var istanceData = data[jQelement.data("field")];
					if (!istanceData) {
						istanceData = data;
					}

					if ( istanceData instanceof Array) {
						if (istanceData.length > 0) {

							$.renderJson(tplId, jQelement, istanceData,data);

						}
					} else {

						$.renderJson(tplId, jQelement, istanceData,data);
					}

				} else {
					var fieldValue = null;
					if (jQelement.data('totranslate')) {
						fieldValue = data[jQelement.data("field") + "_" + $.locale ];
					} else {
                        // controllo che data-field non sia la parola chiave value
                        // se e' value prima controllo che il parametro data sia un oggetto e che abbia la key value
                        // altrimenti il valore e' proprio data e non data[value]
                        if (jQelement.data("field")== 'value' && ( !_.isObject(data) || !(jQelement.data("field") in data) ) )
				            fieldValue =data;
                        else
                            fieldValue = data[jQelement.data("field")];
                            
						// accetto anche i sotto campi del tipo data.field
						var tmp = jQelement.data("field");
						if (tmp.split('.').length == 2) {
							tmp = tmp.split('.');
							fieldValue = data[tmp[0]][tmp[1]];
						}
						
					}
					if (parseInt(jQelement.data('trim')) > 0) {
						var chars = parseInt(jQelement.data('trim'));
						fieldValue = jQuery.trim(fieldValue);
                        if (fieldValue.length > chars)
                            //fieldValue = fieldValue.substring(0, chars).split(" ").slice(0, -1).join(" ") + "...";
                            fieldValue = fieldValue.substring(0, chars) + "...";
					}
					if (jQelement.data('date')) {
						// se aggiungo la T la date tiene conto del locale.
                        // if (fieldValue && fieldValue.length > 10) {
                        //     fieldValue = fieldValue.replace(" ","T");
                        // }

                        var d = new Date(Date.parse(fieldValue));
                        // provo come intero timestamp in millisecondi
                        if (isNaN(d.getTime()))
                            d = new Date(parseInt(fieldValue));

                        if (isNaN(d.getTime()))
                            fieldValue = "";
                        else
                            fieldValue = d.toLocaleDateString($.locale,$.cupparisDateFormat(jQelement.data('date')));


                        // var d = new Date(Date.parse(fieldValue));
                        // if (isNaN(d.getTime()))
                        //     fieldValue = "";
                        // else
						 //  fieldValue = d.toLocaleDateString($.locale,$.cupparisDateFormat(jQelement.data('date')));
					}
					if (jQelement.is("input")) {
		    			jQelement.attr('value',fieldValue);
		            } else if (jQelement.is("select")) {
                        if (jQelement.data("source")) {
                            try {
                                var source = data[jQelement.data("source")];

                                var source_order = [];

                                if (jQelement.data("sourceorder")) {
                                    source_order = data[jQelement.data("sourceorder")];
                                } else {
                                    source_order = _.sortBy(_.keys(source), function (num) {
                                        return num;
                                    });
                                }
                                jQelement.html("");

                                for (var i = 0; i < source_order.length; i++) {
                                    //for (var v in self.data.domainValues) {
                                    var v = source_order[i];

                                    //console.log('OPTIONS: ',v);
                                    var selected = false;

                                    if (v == fieldValue) {
                                        selected = true;
                                    }

                                    var opt = $('<option>').attr({
                                        value : v
                                    });
                                    if (selected)
                                        opt.attr('selected','selected');
                                    opt.html(source[v]);
                                    jQelement.append(opt);

                                }

                                // for (var v in source) {
                                // 	var selected = '';
                                // 	if (fieldValue && (v==fieldValue)) {
                                // 		selected = ' selected="selected" ';
                                // 	}
                                // 	jQelement.append('<option' + selected + ' value="' + v + '">' + source[v] + '</option>');
                                // }
                            } catch(e) {
                                log.error(e);
                            }

                        }
                        else {
                            jQelement.find('option[value="' + fieldValue + '"]').attr('selected','selected');
                        }
                        // TODO manca la selezione del valore corrente
						/*
						 if (fieldValue) {
						 $(this).find('option[value="'+fieldValue+'"]').attr('selected','selected');
						 }
						 */
                        console.log('select',$(this).find('option[value='+fieldValue+']'),fieldValue,jQelement.data("source"));

						/*
						 jQelement.html("");
						 for (var v in fieldValue) {
						 jQelement.append('<option value="' + v + '">' + fieldValue[v] + "</option>");
						 }
						 */
		            } else if (jQelement.is("img")) {
		            	jQelement.attr("src",fieldValue);
		            } else {
		            	if (jQelement.data("append")) {
		            		jQelement.append(fieldValue);
		            	}else if (jQelement.data("prepend")) {
		            		jQelement.prepend(fieldValue);
		            	} else
		            		jQelement.html(fieldValue);
		            }
				}

	    	}
			/*
			if (jQelement.data('self')) {  // i lang non devo fare niente solo controllare l'attributo visible
				if (jQelement.data('template')) {
					$.renderJson(jQelement.data('template'), jQelement, data,data);
					//return ;
				}
	    	}
	    	*/
	    	if (jQelement.data('href')) {
	    		//log.info(data[jQelement.data('href')] + ":" + counter);
	    		//log.info(counter)
	    		var b = eval("with (data) { " + jQelement.data('href') + " }");
	    		jQelement.attr("href",b);
	    	}
	    	if (jQelement.data('id')) {
	    		var b = eval("with (data) { " + jQelement.data('id') + " }");
	    		jQelement.attr("id",b);
	    	}
	        if ( jQelement.data('remove') ) {

	        	var b = eval("with (data) { Boolean(" + jQelement.data('remove') + ") }");
	        	//log.info("data remove ",data,b);
	        	if (b)
	        		jQelement.remove();
	        }
	        if ( jQelement.data('class') ) {
	        	var b = eval("with (data) { " + jQelement.data('class') + " }");
	        	jQelement.attr("class",b);
	        }
	        if ( jQelement.data('addclass') ) {
	        	var b = eval("with (data) { " + jQelement.data('addclass') + " }");
	        	jQelement.addClass(b);
	        }
            if ( jQelement.data('visible') ) {
                var b = eval("with (data) { Boolean(" + jQelement.data('visible') + ") }");
                if (b)
                    jQelement.removeClass('hide');
                else
                    jQelement.addClass('hide');
            }
	        if (jQelement.data('attrs')) {
	        	var s = jQelement.data('attrs');

	        	var b = eval("with (data) { var myattrs=" + jQelement.data('attrs') + " }");
	        	for (var attr in myattrs) {
                    //se e' un attributo data- uso il JSON.stringify per preservare gli oggetti complessi
                    if (attr.indexOf('data-') >= 0 && ($.isArray(myattrs[attr]) || $.isPlainObject(myattrs[attr]) ) ) {
                        jQelement.attr(attr,JSON.stringify(myattrs[attr]) );
                    }
                    else
	                   jQelement.attr(attr,myattrs[attr]);
	        	}
	        	//var myattrs = JSON.parse(b);
	        	//console.log(myattrs);
	        }
	        if (jQelement.data('lang')) {
	        	var def = $.translate(jQelement.data('lang'));
	        	if (jQelement.is("input")) {
	    			jQelement.attr('value',def);
	            } else {
	            	jQelement.html(def);
	            }
	        }
	        if (jQelement.data('html')) {
	        	var b = eval("with (data) { " + jQelement.data('html') + " }");
	        	jQelement.html(b);
	        }
            if (jQelement.data('source') && !jQelement.data('field')) {
                // nel caso di oggetti con valori array se non e' stato settato il field li devo solo riempire (select)
                try {
                    var source = data[jQelement.data("source")];

                    var source_order = [];

                    if (jQelement.data("sourceorder")) {
                        source_order = data[jQelement.data("sourceorder")];
                    } else {
                        source_order = _.sortBy(_.keys(source), function (num) {
                            return num;
                        });
                    }
                    jQelement.html("");

                    for (var i = 0; i < source_order.length; i++) {
                        //for (var v in self.data.domainValues) {
                        var v = source_order[i];

                        //console.log('OPTIONS: ',v);
                        var selected = false;

                        if (v == fieldValue) {
                            selected = true;
                        }

                        var opt = $('<option>').attr({
                            value : v
                        });
                        if (selected)
                            opt.attr('selected','selected');
                        opt.html(source[v]);
                        jQelement.append(opt);

                    }


                } catch(e) {
                    log.error(e);
                }
            }
	        if (jQelement.data('video_icon')) {
	        	var values =data[jQelement.data('video_icon')];

	        	if ("string" == typeof values) {
	        		values = JSON.parse(values);
	        	}
	        	
	        	var thumb = "";
	        	if (values.kind && values.kind.indexOf('youtube') >= 0) {
	        		thumb = values.items[0].snippet.thumbnails.default.url;
	        	} else {
	        		thumb = values[0].thumbnail_small;
	        	}
	        	jQelement.attr("src",thumb);
	        }
	        if (jQelement.data('video_player')) {
	        	var values =data[jQelement.data('video_player')];
	        	var mode = jQelement.data('video_mode');
	        	if ("string" == typeof values) {
	        		values = JSON.parse(values);
	        	}
	        	var video_info = null;
	        	var provider = null;
	        	if (values.kind && values.kind.indexOf('youtube') >= 0) {
	        		video_info = values.items[0];
	        		provider = 'youtube';
	        	} else {
	        		video_info = json[0];
	        		provider = 'vimeo';
	        	}
	        	if (mode == 'dialog') {
	        		if (provider == 'youtube' ) {
	        			
		        		var dialog_data = {
		        				video_id : video_info.id,
		        				provider : 'youtube'
		        		}
		        		console.log(dialog_data)
		        		$(jQelement).attr('data-video_dialog_data',JSON.stringify(dialog_data));
	        		} else {
	        			alert('non implementato');
	        			return ;
	        		}
	        	} else {
	        		if (provider == 'youtube' ) {
	        		
		        		var url= "https://www.youtube.com/v/"+video_info.id;
	        			var id= "dy_"+ (new Date().getTime()) + "_" + (Math.floor(Math.random() * 10000));
	        			jQuery('<div/>', {
	        			    id: id,
	        			    class : 'hide'
	        			}).appendTo(jQelement);
	        			swfobject.embedSWF(url, id, "100%","100%","9.0.0");
	        		}
	        	}
	        	/*
	        	if (values.kind && values.kind.indexOf('youtube') >= 0) {
	        		var video_info = values.items[0];
        			
        			var destContainer = jQelement;
        			if (mode == "dialog") {
        				destContainer = $('#general_dialog .modal-body');
        			}
        			//var obj = $.createDynamicContainer();
        			var id= "dy_"+ (new Date().getTime()) + "_" + (Math.floor(Math.random() * 10000));
        			jQuery('<div/>', {
        			    id: id,
        			    class : 'hide'
        			}).appendTo(destContainer);
        			
        			if (mode == "dialog") {
        				var dialog_data = {
        						id : id,
        						url: url	
        				};
        				$(jQelement).attr('data-video_dialog_data',dialog_data);
        				
        				console.log("mode dialog");
        				$(jQelement).on('click',function () {
        					console.log("clickkkkk");
        					swfobject.embedSWF(url, id, w,h,version);
        					$('#general_dialog').modal('show');
        				});
    	        	} else {
    	        		swfobject.embedSWF(url, id, w,h,version);
    	        	}
    	        	
	        	} else {
	        		var video_info = json[0];
        			console.log(json);
        			var vimeo_html = '<iframe src="'+video_info.url +'"\
        				width="500"\
        				height="210"\
        				frameborder="0"\
        				webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe> <p>\
        				<a href="'+video_info.url +'">Ascension</a> from \
        				<a href="'+video_info.subject_url +'">'+video_info.subject_name +'</a> on \
        				<a href="https://vimeo.com">Vimeo</a>.</p>';
        			$('#player_content').html(vimeo_html);
        			$('#player_video_dialog').modal('show');
	        	}*/
	        	
	        }
		} catch(e) {
			log.warn(sourceContainer, destContainer, data,father,jQelement.prop("tagName"));
			log.error(e);
		}
	};
	var bindEvents = function (container) {
		var evt_selectors = '[data-video_mode="dialog"]';
		$.each($(container).find(evt_selectors), function() {
			if ( $(this).data('video_mode')) {
				
				$(this).unbind('click');
				$(this).click(function () {
					console.log('click');
					var dialog_data = $(this).data('video_dialog_data');
					console.log(dialog_data);
					var id= "dy_"+ (new Date().getTime()) + "_" + (Math.floor(Math.random() * 10000));
					jQuery('<div/>', {
        			    id: id,
        			    class : 'hide'
        			}).appendTo('#generalDialog .modal-body');
					
					if (dialog_data.provider == 'youtube') {
						console.log('dsadsf')
						var url= "https://www.youtube.com/v/"+dialog_data.video_id;
	        			var w = "300px";
	        			var h = "200px";
	        			var version = "9.0.0";
	        			swfobject.embedSWF(url, id, w,h,version);
	        			$('#generalDialog').modal('show').ok(function () {
	        				$('#generalDialog .modal-body').html("");
	        				$('#'+id).remove();
	        			}).cancel(function () {
	        				$('#generalDialog .modal-body').html("");
	        				$('#'+id).remove();
	        			})
					}
				});
			}
		})
	}; 
	var sourceHtml =  $.getDomTemplate(sourceContainer).html();//$(sourceContainer).html();
	$(destContainer).html("");
	var selectors = "[data-field],[data-lang],[data-href],[data-id],[data-visible],[data-attrs],[data-class],[data-self],[data-addclass],";
	selectors += "[data-trim],[data-html],[data-remove],[data-source],[data-video_icon],[data-video_player]";
	//var selectors = "[data-field]";
    if (data instanceof Array) {
    	var startTime = new Date();
    	var tmpDiv = $.createDynamicContainer();
    	for (var k in data) {
    		tmpDiv.html(sourceHtml);
    		$.each(tmpDiv.find(selectors), function() {
				renderJsonElement($(this),data[k],k,data.length);
            });
    		$(destContainer).append(tmpDiv.html());
        }
    	bindEvents(destContainer);
    	var endTime = new Date();
    	var timeDiff = endTime - startTime;
		$.renderTimeAmount += (timeDiff /= 1000);
    	//log.info("RENDER TEMPLATE",timeDiff /= 1000);
    } else { // oggetto singolo
		var startTime = new Date();
        $(destContainer).append(sourceHtml);
        $.each($(destContainer).find(selectors), function() {
			renderJsonElement($(this),data,0,0);
        });
        bindEvents(destContainer);
		var endTime = new Date();
		var timeDiff = endTime - startTime;
		$.renderTimeAmount += (timeDiff /= 1000);
    }

};



/**
 * normalizza il template che contiene sotto template per gestire la ricorsione in caso di
 * template e dati con vettori di vettori
 * @param id : id del template iniziale
 */
$.normalizeTemplate = function (id) {
	var containers = [];

	var _createTemplate = function (html) {
	    jQuery('<div/>', {
	        id: 'self_'+containers.length,
	        class : 'hide'
	      }).appendTo('body');
	      var tmpC = $('#self_'+containers.length);
	      tmpC.html(html);
	      containers.push('#'+tmpC.attr('id'));
	      return tmpC;
	}

	var _normalizeRecursive = function (jQE) {
		//console.log(jQE.attr('id') +  " length " + jQE.find('[data-self]').length)
		if (jQE.find('[data-self]').length == 0) {
			var tmpC = _createTemplate(jQE.html());
			jQE.html("");
			jQE.attr('data-self','#'+tmpC.attr('id'))
			return 1;
	    }

	    $.each(jQE.find('[data-self]'),function () {
	    	var caso_base = _normalizeRecursive($(this));
	    	if (!caso_base) {
	    		var tmpC =_createTemplate($(this).html());
	    		$(this).html("");
	    		$(this).attr('data-self','#'+tmpC.attr('id'));
	    	}
	    });
	    return 0;
	}
	if ($(id).find('[data-self]').length == 0)
		return containers;

	_normalizeRecursive($(id));
	return containers;
}

/**
 * renderizza un template sorgente con i dati attraverso l'utilizzo di dati e
 * gli attributi di configurazione del render stesso.
 * @param sourceSelector : selettore template sorgente
 * @param destSelector : selettore template destinazione
 * @param data : vettore associativo dei dati da utilizzare nel render
 */
$.renderTemplate = function (sourceSelector,destSelector,data) {
	var mainC = $.createDynamicContainer(sourceSelector);
	var containers = $.normalizeTemplate('#'+mainC.attr('id'));
	$.renderJson('#'+mainC.attr('id'),destSelector,data);
	for (var c in containers) {
		$(containers[c]).remove();
	}
	mainC.remove();
}

$.getTemplate = function (sourceSelector,data) {
	var mainD = $.createDynamicContainer();
	$.renderTemplate(sourceSelector, '#'+mainD.attr('id'), data);
	var html = mainD.html();
	mainD.remove();
	return html;
}

$.parseTemplate = function(html, token) {

    var self = this;
    self._replaceAll = function(Source, stringToFind, stringToReplace) {
    	if (!Source)
    		return "Invalid template source";
        if (stringToReplace === null) {
            stringToReplace = '';
        }
        var temp = Source;

        var index = temp.indexOf(stringToFind);
        while (index != -1) {
            temp = temp.replace(stringToFind, stringToReplace);
            index = temp.indexOf(stringToFind);
            //console.log(index);
        }
        return temp;
    };
    try {
        $.each(token, function(key, value) {

            html = self._replaceAll(html, "[" + key + "]", value);//html.replace(new RegExp("\["+key+"\]", 'g'),value);
        });
        var tagjs = {'tagjs': '<script>', '/tagjs': '</script>'};
        $.each(tagjs, function(key, value) {

            html = self._replaceAll(html, "[" + key + "]", value);//html.replace(new RegExp("\["+key+"\]", 'g'),value);
        });
    } catch (e) {
        alert(e.message);
    }
    return html;
};

/**
 * @param upload_field: il controllo upload
 * @callback : funzione richiamata in automatico
 * viene chiamata la callback appena l'utente ritorna dalla selezione di un file
 * associato all'input di controllo upload_field
 */
$.fn.autoUpload = function (callback) {
	$(this).change(callback);

	/* TODO compatibilita' verso ie browser?
	if ($.browser.msie)
	{
	    // IE suspends timeouts until after the file dialog closes
		$(this).click(function(event)
	    {
	        setTimeout(function()
	        {
	            if($(this).val().length > 0) {
	            	callback();
	            }
	        }, 0);
	    });
	}
	else
	{
	    // All other browsers behave
		$(this).change(callback);
	}
	*/
};

// ______________________________________________________________________________
// _______________________________ dialogs ____________________________________
// ______________________________________________________________________________

var __cupparisDialog = {

    _msgToString : function (msg) {
        if (msg && ($.type(msg) == 'array') ) {
            msg = msg.join("<br>");
        }
        return msg;
    },

    _showDialog : function (id,msg) {
        var self = this;
        if ( ($(id).data('bs.modal') || {}).isShown ) {
            $(id + " .msg").html(self._msgToString(msg));
            return $(id);
        }
        $(id + " .msg").html($._msgToString(msg));
        $(id).find('.btok').unbind();
        $(id).find('.btcancel').unbind();
        $(id).modal({backdrop:false,show:true});
        return $(id);
    },

    errorDialog : function(msg) {
        if (!msg) {
            log.error('Errore con messaggio vuoto');
            return ;
        }
        return this._showDialog('#errorDialog',msg);
    },

    messageDialog : function (msg) {
        return this._showDialog('#messageDialog',msg);
    },

    confirmDialog : function (msg) {
        return this._showDialog('#confirmDialog',msg);
    }
};

$._msgToString = function (msg) {
    console.log("_msgToString",msg);
	var m = "No message";
	if (msg) {
    	if ($.type(msg) == 'string')
            m = msg;
        else if ($.type(msg) == 'array')
            m = msg.join("<br>");
    }
	return m;
};

$.errorDialog = function(msg) {
    return __cupparisDialog.errorDialog(msg);
};

$.messageDialog = function(msg) {
    return __cupparisDialog.messageDialog(msg);
};


$.confirmDialog = function(msg) {
    return __cupparisDialog.confirmDialog(msg);
};


$.progressDialog = function(msg, value) {

    var prg_popup = '#progress_dialog';
    $(prg_popup + " .modal-title ").text(msg);
    if (value === false || value === undefined) {
        $(prg_popup + " .progress").css("width", "100%");
        $(prg_popup + " .progress-bar ").text(msg);

    } else {
        $(prg_popup + " .progress").css("width", value + "%");
        $(prg_popup + " .progress-bar ").text(value + "%");
    }
    $(prg_popup).find('.btok').unbind();
	$(prg_popup).find('.btcancel').unbind();
    $(prg_popup).modal('show');
    return $(prg_popup);
};

$.progressDialogClose = function () {
	var prg_popup = '#progress_dialog';
	$(prg_popup).modal("hide");
	return $(prg_popup);
};



$.waitDialogOpen = function(msg) {
    var wait_popup = '#waitDialog';
    $(wait_popup + " .modal-title").html($._msgToString(msg));
    $(wait_popup).find('.btok').unbind();
	$(wait_popup).find('.btcancel').unbind();
    $(wait_popup).modal('show');
    return $(wait_popup);
};

$.generalDialog = function(body,options) {
    var dlg = '#generalDialog';
    if (body)
    	$(dlg + " .modal-body").html(body);
	$(dlg).find('.btok,.btcancel').attr('data-dismiss','modal');
	$(dlg).find('.alert').addClass('hide').html("");
    var opts = options?options:{};
    if (opts.title)
    	$(dlg + " .modal-title").html(opts.title);
    if (opts.hide_buttons)
    	$(dlg + " .modal-footer").addClass("hide");
    else
    	$(dlg + " .modal-footer").removeClass("hide");
    if (opts.btok_label)
    	$(dlg + " .modal-footer").find('.btok').html(opts.btok_label);
    if (opts.btcancel_label)
    	$(dlg + " .modal-footer").find('.btcancel').html(opts.btcancel_label);
	if (opts.autohide == false) {
		$(dlg).find('.btok,.btcancel').attr('data-dismiss','');
	}
    $(dlg).find('.btok').unbind();
	$(dlg).find('.btcancel').unbind();
    $(dlg).modal({backdrop:false,show:true});
    return $(dlg);
};

$.generalDialog.showError = function (msg) {
	var dlg = '#generalDialog';
	$(dlg + " [data-modal_error]").removeClass('hide').html(msg);
}

$.generalDialog.hideError = function () {
	var dlg = '#generalDialog';
	$(dlg + " [data-modal_error]").addClass('hide').html('');
}


$.getFailMessage = function (e) {
	
	try {
		if ($.isProduction)
			return e.status + " " + e.statusText;
		var msg =  e.status + " " + e.statusText + "<br>";
		if ( e.responseJSON) {
			msg += e.responseJSON.error.message + "<br>";
			msg += "line :" + e.responseJSON.error.line + "<br>";
			msg += e.responseJSON.error.file ;
		}
		return msg;
	} catch(em) {
		return ""+em;
	}

};

$.waitDialogClose = function() {
    var wait_popup = '#waitDialog';
    $(wait_popup).modal("hide");
    return $(wait_popup);
};
/**
 * @param titles: array of {dialog:'dialogName',options: {title:'window title'}  }
 */
$.dialogsOption = function(options) {
    for (var i in options) {
        var opt = options[i];
        if (!opt.dialog)
            continue;
        $('#' + opt.dialog).find(".modal-title").html(opt.options.title);
    }
};

$(function() {
    $.containerInit();
});